/**
 * WhatsApp Business API Data Localization Region.
 *
 * Two-letter ISO country code that pins where Meta stores conversation data
 * for a given WABA. Set on the WhatsApp Business Account via Graph API:
 *   POST /{whatsapp_business_account_id}  data_localization_region=<code>
 *
 * The regex-based validation is intentionally permissive — Meta adds new
 * regions periodically, and we don't want a hardcoded enum to reject a
 * valid code Meta has just enabled. The `DATA_LOCALIZATION_REGION_OPTIONS`
 * list below is the canonical set surfaced in the UI dropdown.
 */

export const DATA_LOCALIZATION_REGION_OPTIONS: ReadonlyArray<{
  code: string;
  label: string;
}> = [
  { code: 'AE', label: 'United Arab Emirates' },
  { code: 'AU', label: 'Australia' },
  { code: 'BH', label: 'Bahrain' },
  { code: 'BR', label: 'Brazil' },
  { code: 'CA', label: 'Canada' },
  { code: 'CH', label: 'Switzerland' },
  { code: 'DE', label: 'Germany' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'ID', label: 'Indonesia' },
  { code: 'IN', label: 'India' },
  { code: 'JP', label: 'Japan' },
  { code: 'KR', label: 'South Korea' },
  { code: 'KW', label: 'Kuwait' },
  { code: 'NG', label: 'Nigeria' },
  { code: 'OM', label: 'Oman' },
  { code: 'PK', label: 'Pakistan' },
  { code: 'SA', label: 'Saudi Arabia' },
  { code: 'SG', label: 'Singapore' },
  { code: 'TH', label: 'Thailand' },
  { code: 'TR', label: 'Turkey' },
  { code: 'ZA', label: 'South Africa' },
];

export const DATA_LOCALIZATION_REGION_REGEX = /^[A-Z]{2}$/;

export const isValidDataLocalizationRegion = (code: string): boolean =>
  DATA_LOCALIZATION_REGION_REGEX.test(code);
